import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ThemesState, ThemesStore } from './themes.store';

@Injectable({ providedIn: 'root' })
export class ThemesQuery extends QueryEntity<ThemesState> {
  constructor(protected store: ThemesStore) {
    super(store);
  }
}
